import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { KladerItem, KladerTypePromise } from '@redux/api/Klader/TypePromise';
import { defaultHeaders } from '@redux/api/Config';
import config from '@app/config';

export const kladerApi = createApi({
  reducerPath: 'kladerApi',
  baseQuery: fetchBaseQuery({
    baseUrl: config.baseApiUrl,
    prepareHeaders: defaultHeaders,
  }),
  endpoints: builder => ({
    getAddress: builder.query<KladerTypePromise, string>({
      query: value => `/api/order/suggestAddress-v1?value=${value}`,
      transformResponse: (response: { data }): KladerItem[] => response.data,
    }),
  }),
});

export const { useGetAddressQuery } = kladerApi;
